import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useAuthCore } from '../../core/modules/auth';
import ActiveSessionScreen from '../screens/dashboad/inventoryCount/counting/ActiveSessionScreen';
import MethodSelectionScreen from '../screens/dashboad/inventoryCount/counting/MethodSelectionScreen';
import CountingScreen from '../screens/dashboad/inventoryCount/counting/CountingScreen';

/**
 * Layout minimalista y exclusivo para el rol "Tomador de Inventario": no
 * incluye el menu ni las pantallas normales de Inventaria, solo el flujo
 * de toma de inventario fisico.
 */
const CountingLayout = () => {
  const { logout } = useAuthCore();

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh" bgcolor="grey.50">
      <AppBar position="static" color="default" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Toolbar>
          <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
            Toma de Inventario
          </Typography>
          <Button startIcon={<LogoutOutlinedIcon />} onClick={() => logout()} color="inherit">
            Salir
          </Button>
        </Toolbar>
      </AppBar>

      <Box flex={1}>
        <Routes>
          <Route index element={<ActiveSessionScreen />} />
          <Route path="method/:companyId/:sessionId" element={<MethodSelectionScreen />} />
          <Route path="count/:companyId/:sessionId/:method" element={<CountingScreen />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default CountingLayout;
